import { IAuditorium } from '@core/interfaces/auditorium/auditorium.interface';
import { ADDRESS_MOCK } from '../address/address.mock';

export const AUDITORIUM_VIEW: IAuditorium = {
  id: 'asdasds342d23f',
  name: 'Nagyszínpad',
  isDeleted: false,
  capacity: 420,
  useVenueAddress: false,
  address: { ...ADDRESS_MOCK, city: 'Los Angeles', street: 'Sunset blvd' },
  venueName: 'BestVenue',
  venueId: 'sd273h23t53t94ght',
  venueAddress: ADDRESS_MOCK,
};
